// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3l1Pl","errorLogs":"EditorFooter_errorLogs__2sII_"};